import React from 'react';

import { createClassName } from 'utils/createClassName';

import './dashboardLayoutStyles.scss';

type Props = {
  header: React.ReactNode;
  body: React.ReactNode;
  footer: React.ReactNode;
};

export const DashboardLayoutComponent = (props: Props) => {
  const { header, body, footer } = props;

  const createDashboardLayoutClassName = createClassName('dashboardLayout');

  const wrapperClassName = createDashboardLayoutClassName('wrapper');

  const headerClassName = createDashboardLayoutClassName('header');

  const bodyClassName = createDashboardLayoutClassName('body');

  const contentClassName = createDashboardLayoutClassName('content');

  const footerClassName = createDashboardLayoutClassName('footer');

  return (
    <div className={wrapperClassName}>
      <div className={headerClassName}>{header}</div>
      <div className={bodyClassName}>
        <div className={contentClassName}>{body}</div>
      </div>
      <div className={footerClassName}>{footer}</div>
    </div>
  );
};
